import React from "react";
import { Route, Routes, Navigate, MemoryRouter, useLocation } from "react-router-dom";
import ListArtifactModerator from "./ListArtifactsModerator";

import ArtifactContextLayout from "./ArtifactContextLayout";
import ShowArtifact from "./ShowArtifact";
//import ShowArtifact from "../artifacts/create/container/createArtifact";

import CreatePhoto from "../artifacts/create/CreatePhoto";
import AddEvent from "../artifacts/create/AddEvent";
import AddDocument from "../artifacts/create/AddDocument";
import CreateLinkContent from "../artifacts/create/CreateLink";
import CreateVideo from "../artifacts/create/CreateVideo";
import CreateAudio from "../artifacts/create/CreateAudio";
import GreetingEditor from "../artifacts/create/GreetingEditor";
import AddPlace from "../artifacts/create/AddPlace";
import AddLetter from "../artifacts/create/AddLetter";
import StatusHistory from "./StatusHistory";
import { UpdateListProvider } from "./UpdateListContext";
import { useNavigationBar } from "../../context/NavigationContext";
import ShowArtifactEdits from "./ShowArtifactEdits";
import AddList from "../artifacts/create/AddList";
import AddStory from "../artifacts/create/AddStory";
import AddJournal from "../artifacts/create/AddJournal";
import AddGuide from "../artifacts/create/AddGuide";
import AddPolls from "../artifacts/create/AddPolls";
import AddGreetings from "../artifacts/create/AddGreetings";
import AddJournalVoice from "../artifacts/create/AddJournalVoice";
import AddJournalMemo from "../artifacts/create/AddJournalMemo";
import ContentReports from "./contentReports";

const ContentModerator = () => {
  const location = useLocation();
  const path = location.pathname;
  const { backgroundLocation } = useNavigationBar();
  //const state = location.state as { backgroundLocation?: Location };
  const oldLocation = backgroundLocation?.pathname.includes("/dashboard/contentModeration/list") ? backgroundLocation : location;

  return (
    <>
      <UpdateListProvider>
        <Routes location={oldLocation}>
          <Route path="/" element={<Navigate replace to="./list" />} />
          <Route path="/list" element={<ListArtifactModerator />} />

          <Route element={<ArtifactContextLayout />}>
            {/** container starts here **/}
            <Route path="/list/:id" element={<ShowArtifact />} />
            <Route path="/list/:id/history" element={<StatusHistory />} />
            <Route path="/list/:id/reports" element={<ContentReports />} />

            {/* All the  detailed routes of Creating Specific container */}
            <Route path="/list/:id/addPhotos" element={<CreatePhoto />} />
            <Route path="/list/:id/addEvent" element={<AddEvent />} />
            <Route path="/list/:id/addDocument" element={<AddDocument />} />
            <Route path="/list/:id/addLink" element={<CreateLinkContent />} />
            <Route path="/list/:id/addVideo" element={<CreateVideo />} />
            <Route path="/list/:id/addAudio" element={<CreateAudio />} />
            <Route path="/list/:id/addGreeting" element={<AddGreetings />} />
            <Route path="/list/:id/addPlace" element={<AddPlace />} />
            <Route path="/list/:id/addLetter" element={<AddLetter />} />
            <Route path="/list/:id/addList" element={<AddList />} />
            <Route path="/list/:id/addStory" element={<AddStory />} />
            <Route path="/list/:id/addJournal" element={<AddJournal />} />
            <Route path="/list/:id/addJournalVoice" element={<AddJournalVoice />} />
            <Route path="/list/:id/addJournalMemo" element={<AddJournalMemo />} />
            <Route path="/list/:id/addGuide" element={<AddGuide />} />
            <Route path="/list/:id/addPolls" element={<AddPolls />} />

            {/** container ends here */}
          </Route>

          <Route element={<ArtifactContextLayout isEditingModeration={true} />}>
            <Route path="/list/:id/editsDetails" element={<ShowArtifactEdits />} />
            <Route path="/list/:id/editsDetails/addPhotos" element={<CreatePhoto />} />
            <Route path="/list/:id/editsDetails/addEvent" element={<AddEvent />} />
            <Route path="/list/:id/editsDetails/addDocument" element={<AddDocument />} />
            <Route path="/list/:id/editsDetails/addLink" element={<CreateLinkContent />} />
            <Route path="/list/:id/editsDetails/addVideo" element={<CreateVideo />} />
            <Route path="/list/:id/editsDetails/addAudio" element={<CreateAudio />} />
            <Route path="/list/:id/editsDetails/addGreeting" element={<AddGreetings />} />
            <Route path="/list/:id/editsDetails/addPlace" element={<AddPlace />} />
            <Route path="/list/:id/editsDetails/addLetter" element={<AddLetter />} />
            <Route path="/list/:id/editsDetails/addList" element={<AddList />} />
            <Route path="/list/:id/editsDetails/addStory" element={<AddStory />} />
            <Route path="/list/:id/editsDetails/addJournal" element={<AddJournal />} />
            <Route path="/list/:id/editsDetails/addJournalVoice" element={<AddJournalVoice />} />
            <Route path="/list/:id/editsDetails/addJournalMemo" element={<AddJournalMemo />} />
            <Route path="/list/:id/editsDetails/addGuide" element={<AddGuide />} />
            <Route path="/list/:id/editsDetails/addPolls" element={<AddPolls />} />
          </Route>
        </Routes>
        {backgroundLocation && (
          <Routes>
            <Route element={<ArtifactContextLayout />}>
              {/** container starts here **/}
              <Route path="/list/:id" element={<ShowArtifact />} />
              <Route path="/list/:id/history" element={<StatusHistory />} />
              <Route path="/list/:id/reports" element={<ContentReports />} />
              {/* All the  detailed routes of Creating Specific container */}
              <Route path="/list/:id/addPhotos" element={<CreatePhoto />} />
              <Route path="/list/:id/addEvent" element={<AddEvent />} />
              <Route path="/list/:id/addDocument" element={<AddDocument />} />
              <Route path="/list/:id/addLink" element={<CreateLinkContent />} />
              <Route path="/list/:id/addVideo" element={<CreateVideo />} />
              <Route path="/list/:id/addAudio" element={<CreateAudio />} />
              <Route path="/list/:id/addGreeting" element={<AddGreetings />} />
              <Route path="/list/:id/addPlace" element={<AddPlace />} />
              <Route path="/list/:id/addLetter" element={<AddLetter />} />
              <Route path="/list/:id/addList" element={<AddList />} />
              <Route path="/list/:id/addStory" element={<AddStory />} />
              <Route path="/list/:id/addJournal" element={<AddJournal />} />
              <Route path="/list/:id/addJournalVoice" element={<AddJournalVoice />} />
              <Route path="/list/:id/addJournalMemo" element={<AddJournalMemo />} />
              <Route path="/list/:id/addGuide" element={<AddGuide />} />
              <Route path="/list/:id/addPolls" element={<AddPolls />} />
              {/** container ends here */}
            </Route>
            <Route element={<ArtifactContextLayout isEditingModeration={true} />}>
              <Route path="/list/:id/editsDetails" element={<ShowArtifactEdits />} />
              <Route path="/list/:id/editsDetails/addPhotos" element={<CreatePhoto />} />
              <Route path="/list/:id/editsDetails/addEvent" element={<AddEvent />} />
              <Route path="/list/:id/editsDetails/addDocument" element={<AddDocument />} />
              <Route path="/list/:id/editsDetails/addLink" element={<CreateLinkContent />} />
              <Route path="/list/:id/editsDetails/addVideo" element={<CreateVideo />} />
              <Route path="/list/:id/editsDetails/addAudio" element={<CreateAudio />} />
              <Route path="/list/:id/editsDetails/addGreeting" element={<AddGreetings />} />
              <Route path="/list/:id/editsDetails/addPlace" element={<AddPlace />} />
              <Route path="/list/:id/editsDetails/addLetter" element={<AddLetter />} />
              <Route path="/list/:id/editsDetails/addList" element={<AddList />} />
              <Route path="/list/:id/editsDetails/addStory" element={<AddStory />} />
              <Route path="/list/:id/editsDetails/addJournal" element={<AddJournal />} />
              <Route path="/list/:id/editsDetails/addJournalVoice" element={<AddJournalVoice />} />
              <Route path="/list/:id/editsDetails/addJournalMemo" element={<AddJournalMemo />} />
              <Route path="/list/:id/editsDetails/addGuide" element={<AddGuide />} />
              <Route path="/list/:id/editsDetails/addPolls" element={<AddPolls />} />
            </Route>
          </Routes>
        )}
      </UpdateListProvider>
    </>
  );
};

export default ContentModerator;
